export default class VaultSubmitError extends Error {
  details?: unknown;
  field?: string;
  fieldMessage?: string;
  retryable: boolean;
  type: string;

  constructor({
    message,
    details,
    field,
    fieldMessage,
    retryable,
    type,
  }: {
    message: string;
    details?: unknown;
    field?: string;
    fieldMessage?: string;
    retryable: boolean;
    type: string;
  }) {
    super(message);
    this.details = details;
    this.field = field;
    this.fieldMessage = fieldMessage;
    this.retryable = retryable;
    this.type = type;
  }
}
